import { ref } from 'vue';
import type { SessionInfo } from '@webmail/shared';
import { api } from './api';

/** Aktuelle Sitzung (null = nicht angemeldet) */
export const session = ref<SessionInfo | null>(null);

let loaded: Promise<void> | null = null;

/** Sitzung einmalig beim Laden der Seite abfragen */
export function ensureSession(): Promise<void> {
  loaded ??= api.session().then((s) => {
    session.value = s;
  });
  return loaded;
}

export function setSession(s: SessionInfo | null): void {
  session.value = s;
}
